module.exports = "/_next/static/images/partner-minigood-463d1d2e37d91232bfcb02b49a8b9973.png";